export interface IChatMessage {
  id: number;
  sender: 'user' | 'bot';
  text?: string;
  image?: string;
  timestamp: string | number | Date;
  type: ContentType;
  isDoubtImageResponse?: boolean;
}

export type UiFlowType =
  | 'input'
  | 'questionOptions'
  | 'limit'
  | 'loading'
  | 'error';

export interface ChatHistory {
  rank: number;
  user_input: string;
  ai_response: string;
  user_input_type: ContentType;
}

export enum ContentType {
  IMAGE = 'IMAGE',
  TEXT = 'TEXT'
}

export enum FlowType {
  ASK_NEW_QUESTION = 1,
  CONTINUE_CHAT = 2
}

interface Attachment {
  content_type: ContentType;
  content: string; // S3 Path (for image) or direct text
}

export interface GetAiSolutionParams {
  goalUID: string;
  attachments?: Attachment[];
  history?: ChatHistory[];
}

export interface AiSolutionSuccess {
  daily_limit_exceeded: boolean;
  doubt_number: number;
  solution?: { content: string; content_type: ContentType }[];
  sub_cta_details?: {
    text: string;
    cta_text: string;
  };
}
export interface AiSolutionError {
  message: string;
}

export type AiSolutionResponse = AiSolutionSuccess | AiSolutionError;
